import {isNullOrUndefined} from "../../services/Validator";
import SystemScreenInfoTitleText from "../texts/SystemScreenInfoTitleText";
import SystemScreenInfoSubtitleText from "../texts/SystemScreenInfoSubtitleText";
import SystemScreenErrorIcon from "../icons/SystemScreenErrorIcon";
import {SystemPrimaryCustomButton, SystemSecondaryCustomButton} from "../buttons/SystemCustomButton";
import {kSystemTexts} from "../../constants/texts";
import {kButtonStyles} from "../../constants/styles";
import {CircularProgress} from "@mui/material";

export default function SystemApiFullScreenError({error, isLoading, retryCallback, extraClass}) {
    // Used through the app to display an error object made of
    // error icon, title (problem) and subtitle (reinsurance)

    // BUILD
    if (isNullOrUndefined(error))
        return null
    return (
        <div className={"animate-appear w-[400px] grow flex flex-col justify-center items-center " + extraClass}>
            <SystemScreenErrorIcon />
            <div className={"w-full flex flex-col justify-center items-center mt-[16px]"}>
                <SystemScreenInfoTitleText title={error.statement} />
                <SystemScreenInfoSubtitleText subtitle={error.reassurance} />
            </div>
            <div className={"w-full flex space-x-[12px] mt-[24px]"}>
                <SystemSecondaryCustomButton
                    label={kSystemTexts.home}
                    isDisabled={false}
                    isLoading={false}
                    isFullWidth={true}
                    sizeStyle={kButtonStyles.mediumButtonStyle}
                    onButtonClick={() => retryCallback()} />
                <SystemPrimaryCustomButton
                    label={kSystemTexts.retry}
                    isDisabled={false}
                    isLoading={isLoading}
                    loaderComponent={<CircularProgress size={"24px"}
                                                       style={{'color' : 'white'}} />}
                    isFullWidth={true}
                    sizeStyle={kButtonStyles.mediumButtonStyle}
                    onButtonClick={() => retryCallback()} />
            </div>
        </div>
    );
}